"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var TableCell_1 = __importStar(require("@mui/material/TableCell"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var InputIconButton = __importStar(require("./M_InputIconButton"));
var icons_1 = require("./icons");
var Component = function (p) {
    var _a;
    var extensions = {
        '3DS Max': 'max',
        Blender: 'blend',
        GLB: 'glb',
        'JSON (Attachments)': 'json',
        'Blender (Attachments)': 'blend',
    };
    var onDownload = function (location) {
        if (location)
            p.onDownload(location);
    };
    return (Preact.h(TableRow_1.default, { sx: (_a = {},
            _a["& .".concat(TableCell_1.tableCellClasses.root)] = {
                borderBottom: 'none',
            },
            _a) },
        Preact.h(TableCell_1.default, null, p.format),
        Preact.h(TableCell_1.default, null, p.location && (Preact.h(Link_1.default, { href: p.location, sx: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical',
            } }, p.location))),
        Preact.h(TableCell_1.default, null, p.created),
        Preact.h(TableCell_1.default, null, p.lastModified),
        Preact.h(TableCell_1.default, { sx: { display: 'flex', justifyContent: 'center' } },
            Preact.h(InputIconButton.Component, { sx: { marginRight: '5px' }, accept: [".".concat(extensions[p.format])], icon: Preact.h(icons_1.UploadIcon, { htmlColor: "black", fontSize: "small" }), onChange: function (f) {
                    return p.onUpload({
                        kind: p.kind,
                        extension: extensions[p.format],
                        file: f,
                        model: { productId: p.productId, articleType: p.articleType },
                    });
                } }),
            Preact.h(IconButton_1.default, { disabled: !p.location, size: "small", onClick: function () { return onDownload(p.location); } },
                Preact.h(icons_1.DownloadIcon, { htmlColor: p.location ? 'black' : 'inherit', fontSize: "small" })))));
};
exports.Component = Component;
